define('ItemAvailability.LiveOrderUpdate.Model', [
    'Backbone',
    'Utils'
], function ItemAvailabilityLiveOrderUpdateModel(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        /* eslint-disable */
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ItemAvailability.Service.ss'))
        /* eslint-enable */
    });
});
